<script setup lang="ts">
import { useRouter } from "vue-router";
import { storeToRefs } from "pinia";
import { useAuthStore } from "@/stores/auth";
import { onMounted } from "vue";
import { useSearchStore } from "@/stores/search";
import OrdersResult from "@/components/searchresult/OrdersResult.vue";
import UsersResult from "@/components/searchresult/UsersResult.vue";
import DevicesResult from "@/components/searchresult/DevicesResult.vue";
import LegacyDevicesResult from "@/components/searchresult/LegacyDevicesResult.vue";
import PromotionCodesResult from "@/components/searchresult/PromotionCodesResult.vue";
import PromotionCodeHistoryResult from "@/components/searchresult/PromotionCodeHistoryResult.vue";
import BatchIdResult from "@/components/searchresult/BatchIdResult.vue";

const auth = useAuthStore();
const router = useRouter();
const { role } = storeToRefs(auth);
const search = useSearchStore();
const {
  orderResult,
  orderPromotionResult,
  userResult,
  promotionResult,
  promotionHistoryResult,
  deviceResult,
  legacyDeviceResult,
  batchIdResult,
  searching,
  errorMessage,
  emptyResult,
} = storeToRefs(search);
// orders
// all have date, but only have deviceid from 2021-06-23, and can sometimes be "web"

// postcards
// properties available have varied over time, but groups on orderId

// users, start existing in oct 2021

// legacydevices, deprecated march 26 2022
// same id could possibly have both legacy and new device, but cx-type ref only marks new devices
onMounted(() => {
  if (role.value === "stralfors") {
    router.replace("/sf");
  }
  if (role.value === "newsletter") {
    router.replace("/newsletter");
  }
});
const onSearch = async (e: any) => {
  await search.search(e.detail);
};
</script>

<template>
  <h1 v-if="role">Search</h1>
  <section v-if="role">
    <div class="search">
      <pn-search-field
        name="query"
        v-on:search="onSearch"
        :loading="searching"
        label=""
      >
      </pn-search-field>
    </div>
    <p>
      Search for support reference, orderid, userid, user email, promotion code,
      zip file name ...
    </p>
    <p v-show="errorMessage">
      <pn-toast
        closable="false"
        appearance="error"
        :text="errorMessage"
      ></pn-toast>
    </p>
    <p v-show="emptyResult">
      <pn-toast
        closable="false"
        text="Your search returned no results"
      ></pn-toast>
    </p>
  </section>
  <OrdersResult :orders="orderResult" :searching="searching" />
  <OrdersResult
    :orders="orderPromotionResult"
    title="Orders with promotion code"
    :searching="searching"
  />
  <UsersResult :users="userResult" :searching="searching" />
  <DevicesResult :devices="deviceResult" :searching="searching" />
  <LegacyDevicesResult
    :legacyDevices="legacyDeviceResult"
    :searching="searching"
  />
  <PromotionCodesResult :codes="promotionResult" :searching="searching" />
  <PromotionCodeHistoryResult
    :codes="promotionHistoryResult"
    :searching="searching"
  />
  <BatchIdResult :orders="batchIdResult" :searching="searching" />
</template>
<style lang="scss" scoped>
pn-search-field {
  width: 550px;
}
</style>
